<div class="ha-screenings-section section-wrapper">
	<div id="medical-screening">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.medical-history.screening.heading'">Health Screenings</span>
		</div>
		<div
			class="radio-btn-label"
			[translate]="'wellness.health-assessment-new.medical-history.screening.form-fields.screenings'">
			Please indicate any screenings you have had in the past year.
		</div>
		<div class="checkbox-list" [formGroup]="screeningsForm">
			<div>
				<mat-checkbox value="true" appAutofocus formControlName="hadPapTest">
					<span [translate]="'wellness.health-assessment-new.medical-history.screening.check-box.pap-test'"
						>Pap Test</span
					>
				</mat-checkbox>
				<div *ngIf="screeningsForm.get('hadPapTest').value">
					<mat-form-field appearance="fill">
						<mat-label
							><span
								[translate]="'wellness.health-assessment-new.medical-history.screening.form-fields.year-of-pap-test'"
								>Year of Pap Test</span
							></mat-label
						>
						<input matInput formControlName="yearOfPapTest" [readOnly]="readOnly" [imask]="yearMask.iMaskArgs" />
					</mat-form-field>
				</div>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadMammography">
					<span [translate]="'wellness.health-assessment-new.medical-history.screening.check-box.mammo'"
						>Mammography</span
					>
				</mat-checkbox>
				<div *ngIf="screeningsForm.get('hadMammography').value">
					<mat-form-field appearance="fill">
						<mat-label
							><span [translate]="'wellness.health-assessment-new.medical-history.screening.form-fields.year-of-mammo'"
								>Year of Mammography</span
							></mat-label
						>
						<input matInput formControlName="yearOfMammography" [readOnly]="readOnly" [imask]="yearMask.iMaskArgs" />
					</mat-form-field>
				</div>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadCst">
					<span [translate]="'wellness.health-assessment-new.medical-history.screening.check-box.cst'"
						>Cardiac Stress Test</span
					>
				</mat-checkbox>
				<div *ngIf="screeningsForm.get('hadCst').value">
					<mat-form-field appearance="fill">
						<mat-label
							><span [translate]="'wellness.health-assessment-new.medical-history.screening.form-fields.year-of-cst'"
								>Year of Cardiac Stress Test</span
							></mat-label
						>
						<input matInput formControlName="yearOfCst" [readOnly]="readOnly" [imask]="yearMask.iMaskArgs" />
					</mat-form-field>
				</div>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadColonoscopy">
					<span [translate]="'wellness.health-assessment-new.medical-history.screening.check-box.colonoscopy'"
						>Colonoscopy</span
					>
				</mat-checkbox>
				<div *ngIf="screeningsForm.get('hadColonoscopy').value">
					<mat-form-field appearance="fill">
						<mat-label
							><span
								[translate]="'wellness.health-assessment-new.medical-history.screening.form-fields.year-of-colonoscopy'"
								>Year of Colonoscopy</span
							></mat-label
						>
						<input matInput formControlName="yearOfColonoscopy" [readOnly]="readOnly" [imask]="yearMask.iMaskArgs" />
					</mat-form-field>
				</div>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadDexa">
					<span [translate]="'wellness.health-assessment-new.medical-history.screening.check-box.dexa'"
						>Bone Density Scan (DEXA)</span
					>
				</mat-checkbox>
				<div *ngIf="screeningsForm.get('hadDexa').value">
					<mat-form-field appearance="fill">
						<mat-label
							><span [translate]="'wellness.health-assessment-new.medical-history.screening.form-fields.year-of-dexa'"
								>Year of Bone Density Scan (DEXA)</span
							></mat-label
						>
						<input matInput formControlName="yearOfDexa" [readOnly]="readOnly" [imask]="yearMask.iMaskArgs" />
					</mat-form-field>
				</div>
			</div>
		</div>
	</div>
	<div id="medical-vaccination" class="vaccinations">
		<div class="heading">
			<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.heading'">Vaccinations</span>
		</div>
		<div
			class="radio-btn-label"
			[translate]="'wellness.health-assessment-new.medical-history.vaccinations.form-fields.vaccinations-had'">
			Please indicate the vaccinations you know you have had.
		</div>
		<div class="checkbox-list" [formGroup]="vaccinationsForm">
			<div>
				<mat-checkbox value="true" formControlName="hadFlu">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.check-box.flu'"
						>Flu (Influenza)</span
					>
				</mat-checkbox>
				<div *ngIf="vaccinationsForm.get('hadFlu').value">
					<mat-form-field appearance="fill">
						<mat-label
							><span
								[translate]="
									'wellness.health-assessment-new.medical-history.vaccinations.form-fields.date-of-vaccination-flu'
								"
								>Date of last vaccination</span
							></mat-label
						>
						<input matInput formControlName="dateOfLastFlu" [readOnly]="readOnly" />
					</mat-form-field>
				</div>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadHepA">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.check-box.hepatitis-a'"
						>Hepatitis A Series</span
					>
				</mat-checkbox>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadHepB">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.check-box.hepatitis-b'"
						>Hepatitis B Series</span
					>
				</mat-checkbox>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadHpv">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.check-box.hpv'"
						>HPV Series</span
					>
				</mat-checkbox>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadMmr">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.check-box.mmr'"
						>MMR (Measles, Mumps, and Rubella)</span
					>
				</mat-checkbox>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadPneumonia">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.check-box.pneumonia'"
						>Pneumonia (Pneumovax and/or Prevnar)</span
					>
				</mat-checkbox>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadShingles">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.check-box.shingles'"
						>Shingles (Shingrix) Series</span
					>
				</mat-checkbox>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadTetanus">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.check-box.tetanus'"
						>Tetanus/Diptheria</span
					>
				</mat-checkbox>
				<div *ngIf="vaccinationsForm.get('hadTetanus').value">
					<mat-form-field appearance="fill">
						<mat-label
							><span
								[translate]="
									'wellness.health-assessment-new.medical-history.vaccinations.form-fields.date-of-vaccination-tetanus'
								"
								>Date of last vaccination</span
							></mat-label
						>
						<input matInput formControlName="yearLastTetanus" [readOnly]="readOnly" />
					</mat-form-field>
				</div>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadTdap">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.check-box.tdap'">Tdap</span>
				</mat-checkbox>
				<div *ngIf="vaccinationsForm.get('hadTdap').value">
					<mat-form-field appearance="fill">
						<mat-label
							><span
								[translate]="
									'wellness.health-assessment-new.medical-history.vaccinations.form-fields.date-of-vaccination-tdap'
								"
								>Date of last vaccination</span
							></mat-label
						>
						<input matInput formControlName="yearLastTdap" [readOnly]="readOnly" />
					</mat-form-field>
				</div>
			</div>
			<div>
				<mat-checkbox value="true" formControlName="hadChickenpoxVaccine">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.check-box.chickenpox'"
						>Chickenpox</span
					>
				</mat-checkbox>
			</div>
			<div
				class="radio-btn-label radio"
				[translate]="'wellness.health-assessment-new.medical-history.vaccinations.form-fields.ever-had-chicken-pox'">
				Have you ever had Chickenpox?
			</div>

			<mat-radio-group formControlName="everHadChickenpox">
				<mat-radio-button [value]="true">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.form-fields.option-yes'"
						>Yes</span
					>
				</mat-radio-button>
				<mat-radio-button [value]="false">
					<span [translate]="'wellness.health-assessment-new.medical-history.vaccinations.form-fields.option-no'"
						>No</span
					>
				</mat-radio-button>
			</mat-radio-group>
		</div>
	</div>
</div>
<div *ngIf="!readOnly" class="save-btn {{ readOnly ? 'read-only' : '' }}" (click)="next()">
	<button class="button button-medium" mat-button appEheAnalytics [data]="analyticsData">
		<span *ngIf="returningUser" [translate]="'wellness.health-assessment-new.update-button'">Update</span>
		<span *ngIf="!returningUser" [translate]="'wellness.health-assessment-new.next-button'">Next</span>
	</button>
</div>
